import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import mixin from 'react-mixin';
import { forwardPropsToState } from '../../../utils/react_utils';
import LecomLabel from '../label/label';
import { FormAPI } from 'lecom-api';
import { FormEvents } from '../../../form/events/form_event_handler';

@mixin.decorate(window.CssClassMixin)
@mixin.decorate(window.InputComponentMixin)
@forwardPropsToState([{ prop: 'value' }])

export default class InputDatepickerMobile extends React.Component {
	constructor(props) {
		super(props);
		this.isActive = true;

		this.handleComplete = this.handleComplete.bind(this);
		this.handleMaskIncomplete = this.handleMaskIncomplete.bind(this);
		this.handleCalendarClick = this.handleCalendarClick.bind(this);
		this.handlePickadateSet = this.handlePickadateSet.bind(this);
	}

	getDateFormat() {
		return (this.props.dateFormat || Realize.i18n.t('date.formats.date'));
	}

	componentDidMount() {
		const $input = $(ReactDOM.findDOMNode(this.refs.input));

		$input.inputmask(this.getDateFormat().toLowerCase().replace(/[a-z]/g, '9'), {
			showMaskOnHover: false,
			oncomplete: this.handleComplete,
			onincomplete: this.handleMaskIncomplete
		});

		$input.pickadate({
			editable: true,
			selectMonths: true,
			selectYears: true,
			format: this.getDateFormat().toLowerCase(),
			onSet: this.handlePickadateSet
		});
	}

	handleMaskIncomplete() {
		this.setState({ value: "" });
	}

	handleComplete(event) {
		const value = event.target.value;
		this.setState({ value });

		const field = this.getFieldAPI();
		if (field) {
			field.value(value).apply();
		}
	}

	handlePickadateSet(pickadateObject) {
		const pickedDate = pickadateObject.select;
		if (!pickedDate && !pickadateObject.hasOwnProperty("clear")) return;
		const format = this.getDateFormat().toUpperCase();
		const value = moment(pickedDate).format(format);
		this.setState({ value });

		const field = this.getFieldAPI();
		if (field) {
			field.value(value).apply();
		}

		$(ReactDOM.findDOMNode(this.refs.input)).pickadate('close');
	}

	handleCalendarClick(event) {
		const $input = $(ReactDOM.findDOMNode(this.refs.input));
		const picker = $input.pickadate('picker');

		setTimeout(() => { this.tabOrderCalendar() }, 500);

		/* TODO: should close on date click - materialize currently broke it
		Foi usado timeout para corrigir o problema de perda de foco do picker, o metodo de close estava sendo chamado duas vezes apos o open */
		(picker.get('open'))
			? picker.close()
			: setTimeout(() => picker.open(), 100);

		event.stopPropagation();

		const field = this.getFieldAPI();

		if (field) {
			field.publish(FormEvents.CLICK);
		}
	}

	getFieldAPI() {
		if (this.props.formId) {
			const formAPI = FormAPI.form(this.props.formId);
			return (this.props.gridFormParent)
				? formAPI.fields(this.props.gridFormParent).fields(this.props.id)
				: formAPI.fields(this.props.id);
		}
		return null;
	}

	render() {
		return (
			<div className="container-datepicker-mobile">			
				<input
					{...this.props}
					className={`${this.inputClassName()} datepicker-mobile`}
					onChange={this._handleChange.bind(this)}
					onFocus={this._handleFocus.bind(this)}
					type="text"
					placeholder={this.getDateFormat()}
					value={this.state.value || ""}
					autoCorrect="off"
					ref="input"
				/>

				<Button
					disabled={this.props.disabled || this.props.readOnly}
					icon={{ type: 'calendar' }}
					role="button"
					className={`input-datepicker__button prefix button-date`}
					onClick={this.handleCalendarClick}
					type="button"
					ref="button"
				/>

				<LecomLabel
					{...this.propsWithoutCSS()}
					active={this.isActive}
				/>
			</div>
		);
	}
}